import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { RouterProvider } from "@tanstack/react-router";
import { StrictMode } from "react";
import { createRoot } from "react-dom/client";

import { initializeTheme, ThemeProvider } from "./components/ThemeProvider";
import { DeploymentUpdateProvider } from "./components/DeploymentUpdates";
import { ShellViewModeProvider } from "./components/ShellViewModeProvider";
import { schedulePlatformServiceWorkerRegistration } from "./pwa/register-service-worker";
import { router } from "./router";
import "./styles.css";

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,
      retry: 1,
    },
    mutations: {
      retry: false,
    },
  },
});

const root = document.querySelector("#root");
if (!root) throw new Error("CCBox root element was not found");

initializeTheme();
schedulePlatformServiceWorkerRegistration();

createRoot(root).render(
  <StrictMode>
    <ThemeProvider>
      <ShellViewModeProvider>
        <QueryClientProvider client={queryClient}>
          <DeploymentUpdateProvider>
            <RouterProvider router={router} />
          </DeploymentUpdateProvider>
        </QueryClientProvider>
      </ShellViewModeProvider>
    </ThemeProvider>
  </StrictMode>,
);
